import { defineMessages } from 'react-intl-next';
export var placeholderTextMessages = defineMessages({
  placeholderTextPlaceholder: {
    id: 'fabric.editor.placeholderTextPlaceholder',
    defaultMessage: 'Add placeholder text',
    description: ''
  }
});